import { get } from "lodash";
import React, { memo, useCallback, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setIsOffCanvasThreeOpen } from "../../commonSlice.js";
import DrillDownOffCanvasThree from "./DrillDownOffCanvasThree.jsx";
import { observabilityApi } from "../../services/observabilityApi.js";
import CompleteTableData from '../Table/CompleteTableData.jsx';
import CustomTab from "../Tab/index.jsx";
import PropTypes from 'prop-types';
import "./features.common.styles.scss";

const DdDefaultSummary = (props) => {

  const tableData = props?.tableData?.filter(item => item.issueId !== undefined);

  function toTitleCase(str) {
    if (typeof str !== 'string') {
      return '';
    }

    return str.replace(/\w\S*/g, function (txt) {
      if (txt.toLowerCase() === 'prodfix' || txt.toLowerCase() === 'prod-fix') {
        return 'ProdFix';
      }
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  const tableTitle = toTitleCase(props ? (props?.gridState?.gridState?.seriesName) : "");
  const dispatch = useDispatch();
  const { summaryTitle, summaryList } = props;
  const commonSliceState = useSelector((state) => state.common);
  const { common } = useSelector((state) => state);
  const selectedData = get(commonSliceState, "offcanvasState.selectedData", []);
  const selectedTittle = get(commonSliceState, "offcanvasState.title", []);
  const selectedLevelOne = get(
    commonSliceState,
    "drillDownSelectionState.selectedLevelOne",
    []
  );
  const [getFlowJiraDetails] = observabilityApi.useGetFlowJiraDetailsMutation();
  const [getFlowJiraSprintLists] = observabilityApi.useGetFlowJiraSprintListsMutation();
  const openDrillDownThree = async (summaryData) => {
    const payload = {
      appCodes: [],
      jiraKey: summaryData.issueId,
      projects: [],
      sprintName: [],
      startDt: "",
      toDt: ""
    };
    try {
      const jiraDetails = await getFlowJiraDetails(payload);
      const jiraSprintLists = await getFlowJiraSprintLists(payload);
      dispatch(
        setIsOffCanvasThreeOpen({
          isDrilldownThreeOpen: true,
          title: selectedTittle,
          selectedData: [jiraDetails, jiraSprintLists]
        })
      );
    } catch (error) {
      console.error("Error occurred while fetching data: ", error);
      // Handle error here, such as showing an error message to the user
    }
  };
  const isSummaryListEmpty =
    selectedLevelOne === ""
      ? false
      : !summaryList || summaryList.length === 0;

  let columns = [
    {
      Header: "Sl.No",
      accessor: "Sl.No", // Serial number starts from 1
      tdClassName: "text-center flowmetricsGridSN",
      Cell: ({ row }) => {
        let serialNumber;
        if (props.gridState.gridState.pageNumber > 0) {
          let idx = row.index + 1;
          serialNumber = (props.gridState.gridState.pageNumber * props.gridState.gridState.itemsPerPage) + idx;
        } else {
          serialNumber = row.index + 1;
        }
        return (
          <>
            <div style={{ paddingRight: "18px" }}>{serialNumber}</div>
          </>
        );
      },
    },
    {
      Header: "Jira Issue Key",
      accessor: "issueId",
      Cell: ({ value, row }) => {
        const shouldHighlight = row.values.issueId;

        return (
          <td
            id="PluginClick"
            className={`text-center ${shouldHighlight ? "tableRedHighlight" : ""
              }`}
            onClick={() => openDrillDownThree(row.values)}
          >
            {value ? value : "-"}
          </td>
        );
      },
    },
    {
      Header: "Summary",
      accessor: "summary",
      tdClassName: "drilldowngrid"
    },
  ];
  if (selectedTittle === "Flow Velocity & Time") {
    const issueIdIndex = _.findIndex(columns, { Header: "Jira Issue Key" });
    columns.splice(issueIdIndex + 1, 0, {
      Header: "Days to Complete",
      accessor: "daysToComplete",
      Cell: ({ value }) => <div className="text-center">{value}d</div>,
    });
  }
  if (selectedTittle === "Flow Predictability") {
    columns = [
      ...columns,
      {
        Header: "Status",
        accessor: "status",
        tdClassName: "text-center",
        Cell: ({ value }) => {
          let className;

          if (value === "Not Worked") {
            className = "status-badge_NotWorked";
          } else if (value === "Completed") {
            className = "status-badge_Completed";
          } else {
            className = "status-badge_InProgress ";
          }

          return (
            <div style={{ fontWeight: 'bold', color: value === 'Completed' ? 'green' : 'black' }}>
              <td className={`badge flowmetrics-badge text-center text-dark ${className}`}>
                {value}
              </td>
            </div>
          );
        },
      },
    ];
  }


  if (selectedTittle === "Flow Efficiency") {
    columns = [
      ...columns,
      {
        Header: "Active Time(hr)",
        accessor: "activeTime",
        tdClassName: "text-center",
        Cell: ({ value }) => {
          // Convert value to a number and round it to three decimal places
          const roundedValue = Number(value).toFixed(2);
          return roundedValue;
        },
      },
      {
        Header: "Waiting Time(hr)",
        accessor: "waitTime",
        tdClassName: "text-center",
        Cell: ({ value }) => {
          // Convert value to a number and round it to three decimal places
          const roundedValue = Number(value).toFixed(2);
          return roundedValue;
        },
      },
    ];
  }


  const handlePageLimitChange = useCallback((pageLimit) => {
    props.getLimit(pageLimit);
  }, [props]);

  const handlePageNoChange = useCallback((pageNumber) => {
    props.getPage(pageNumber);
  }, [props]);

  const onSearch = useCallback((e) => {
    props.getSearchKey(e);
  }, [props]);

  const [activeTabKey, setActiveTabKey] = useState("Planned");

  const handleactiveTabKey = useCallback((key) => {
    setActiveTabKey(key);
    props.getactiveTabKey(key);
  }, [props]);

  const tabData = [
    {
      text: "Planned",
      function: (<h1></h1>),//for any function happen while tab switching
      key: "Planned",
    },
    {
      text: "Unplanned",
      function: (<h1></h1>),
      key: "Unplanned",
    },
  ];
  return (
    <>
      {common.offcanvasThreeState.isDrilldownThreeOpen && <DrillDownOffCanvasThree flowMetricsShow={true} />}
      <div className="stories-list" style={props.unsetStoriesHeight ? { maxHeight: 'unset', overflowY: 'unset' } : null}>
        <h3 className="gridtitleflowMetrics">{tableTitle}</h3>

        {!selectedTittle === "Flow Predictability" && <h5 className="drillFontflow">
          {summaryTitle && !selectedTittle === "Flow Predictability"
            ? summaryTitle
            : selectedLevelOne === "risk"
              ? "Risks"
              : selectedLevelOne !== ""
                ? selectedLevelOne === "prodFix"
                  ? "Prod-fix"
                  : selectedLevelOne === "MINOR"
                    ? "Low"
                    : selectedLevelOne === "MAJOR"
                      ? "High"
                      : selectedLevelOne
                : "Summary"}
        </h5>}
        <div className="row">
          {selectedData.rightSummaryHeader
            ? selectedData.rightSummaryHeader(selectedData, selectedLevelOne)
            : ""}
        </div>

        <div>
          <table
            className={
              selectedTittle === "LEVEL OF COLLABORATION BY COMMENTS"
                ? ""
                : "summary_header "
            }
            id="VTC_summary"
          >
            {selectedData.customSummaryHeader ? (
              selectedData.customSummaryHeader()
            ) : !selectedData.DdtopAssigneeCustomSummary && selectedTittle !== "Flow Distribution" && selectedTittle !== "Flow Velocity & Time" && selectedTittle !== "Flow Predictability" && selectedTittle !== "Flow Efficiency" && selectedTittle !== "Flow Load (Active Sprint)" ? (
              <>
                <thead>
                  <tr>
                    <th className="w-5p">Sl.No</th>
                    <th className="w-20p">Issue Key</th>
                    <th className="w-75p">Summary</th>
                  </tr>
                </thead>
              </>
            ) : null}
            {(selectedTittle === "NO. OF CHANGE REQUESTS" ||
              selectedTittle === "NO. OF CHANGE REQUESTS (PER CATEGORY)" ||
              selectedTittle === "NO. OF INCIDENTS" ||
              selectedTittle === "NO. OF INCIDENTS (PER CATEGORY)" ||
              selectedTittle === "NO. OF CHANGE REQUESTS (PER RISK)") && (
                <thead>
                  <tr>
                    <th className="w-5p">Sl.No</th>
                    <th className="w-20p">Issue Key</th>
                    <th className="w-75p">Summary</th>
                  </tr>
                </thead>
              )}
            {

              !isSummaryListEmpty ? (
                selectedData.DdFlowPredictCustomSummary ? (
                  <tbody className="accordion">
                    {summaryList.map((summaryData) => {
                      return selectedData.customSummaryList(summaryData);
                    })}
                  </tbody>
                ) : (
                  <tbody className="summary_part">
                    {selectedTittle !== "Flow Velocity & Time" && selectedTittle !== "Flow Predictability" && summaryList.map((summaryData, index) => {
                      return selectedData.customSummaryList ? (
                        selectedData.customSummaryList(summaryData)
                      ) : (
                        <tr>
                          <td className="text-nowrap px-3">{index + 1}</td>
                          <td className="fw-20 text-nowrap px-1">{summaryData.issueId}</td>
                          <td className="fw-80">{summaryData.summary}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                )
              ) : null}
          </table>

          {selectedTittle === "Flow Predictability" && (
            <CustomTab
              customTab="mb-3 p-0 customTab"
              data={tabData || []}
              activeKey={activeTabKey}
              onTabChange={handleactiveTabKey}
              CustomTab />
          )}

        </div>
        {
          (selectedTittle === "Flow Efficiency" ||
            selectedTittle === "Flow Velocity & Time" ||
            selectedTittle === "Flow Predictability" ||
            selectedTittle === "Flow Load (Active Sprint)" ||
            selectedTittle === "Flow Distribution") ? (
            props.gridState !== undefined ? (
              <CompleteTableData
                isLoading={props.gridState.gridLoading}
                data={tableData}
                columns={columns}
                pageLimit={props.gridState.gridState.itemsPerPage}
                onPageLimitChange={handlePageLimitChange}
                curentPageNumber={props.gridState.gridState.pageNumber}
                onPageNoChange={handlePageNoChange}
                totalPageCount={props.gridState.totalPageCount}
                listCount={props.gridState.listCount}
                onSearch={onSearch}
                searchKey={props.gridState.gridState.searchKey}
              />
            ) : null
          ) : null
        }

      </div>
    </>
  );
};
export default memo(DdDefaultSummary);


DdDefaultSummary.propTypes = {
  tableData: PropTypes.arrayOf(
    PropTypes.shape({
      issueId: PropTypes.string,
      summary: PropTypes.string,
      daysToComplete: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      status: PropTypes.string,
      activeTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      waitTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  gridState: PropTypes.shape({
    gridLoading: PropTypes.bool,
    listCount: PropTypes.number,
    totalPageCount: PropTypes.number,
    gridState: PropTypes.shape({
      seriesName: PropTypes.string,
      pageNumber: PropTypes.number,
      itemsPerPage: PropTypes.number,
      searchKey: PropTypes.string,
    }),
  }),
  summaryTitle: PropTypes.string,
  summaryList: PropTypes.arrayOf(
    PropTypes.shape({
      issueId: PropTypes.string,
      summary: PropTypes.string,
    })
  ),
  unsetStoriesHeight: PropTypes.bool,
  getLimit: PropTypes.func,
  getPage: PropTypes.func,
  getSearchKey: PropTypes.func,
  getactiveTabKey: PropTypes.func,
  value: PropTypes.string,
  row: PropTypes.object.isRequired,
};



